import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import useFormValidator from 'useFormValidator';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function TransmittalModal({
  checkTransmittal,
  type
}) {
  const [formData, setFormData] = useState({
    bpls_batch_number: '',
  });
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const validateForm = useFormValidator(formData, {
    bpls_batch_number: 'required|number',
  });
  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // eslint-disable-next-line consistent-return
  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const src = `${process.env.REACT_APP_WS}${c.BPLS_REPRINT_TRANSMITTAL}?bearer_token=${token}
    )}&bpls_batch_number=${_.get(formData, 'bpls_batch_number')}&email=${_.get(
      authProfile,
      'email'
    )}&type=${type}`;

    const payload = {
      bpls_batch_number: _.get(formData, 'bpls_batch_number'),
      email: _.get(authProfile, 'email'),
      type
    };

    checkTransmittal(payload, (res) => {
      if (_.isEmpty(res.data)) {
        setTimeout(() => {
          window.location.href = src;
        }, 100);
        setModal({ isOpen: false });
      }
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Batch Number: {validateForm.renderMessage('bpls_batch_number')}
            </label>
            <input
              className="form-control"
              type="number"
              min="1"
              name="bpls_batch_number"
              onChange={onChange}
              value={_.get(formData, 'bpls_batch_number')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              Print
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

TransmittalModal.propTypes = {
  type: PropTypes.string,
  checkTransmittal: PropTypes.instanceOf(Function).isRequired,
};

TransmittalModal.defaultProps = {
  type: '',
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TransmittalModal);
